import React from 'react';

/**
 * Skeleton loaders for dashboard cards and tables.
 */
export function Skeleton({ width, height = 16, className = '' }) {
  const style = {};
  if (width) style.width = typeof width === 'number' ? `${width}px` : width;
  if (height) style.height = typeof height === 'number' ? `${height}px` : height;
  return <span className={`ui-skeleton ${className}`.trim()} style={style} />;
}

export function SkeletonCard() {
  return (
    <div className="ui-card ui-skeleton-card">
      <div className="ui-card__header">
        <Skeleton width={120} height={20} />
        <Skeleton width={48} height={24} />
      </div>
      <div className="ui-card__body">
        <Skeleton width="100%" height={40} />
        <Skeleton width="80%" height={12} />
        <Skeleton width="60%" height={12} />
      </div>
    </div>
  );
}
